import React from 'react';

export const PlayIcon: React.FC<{ color?: string; className?: string }> = ({ color, className }) => {
  return (
    <svg
      className={className}
      width='37'
      height='36'
      viewBox='0 0 37 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M34.25 18C34.25 26.6985 27.1985 33.75 18.5 33.75C9.80152 33.75 2.75 26.6985 2.75 18C2.75 9.30152 9.80152 2.25 18.5 2.25C27.1985 2.25 34.25 9.30152 34.25 18ZM36.5 18C36.5 27.9411 28.4411 36 18.5 36C8.55887 36 0.5 27.9411 0.5 18C0.5 8.05887 8.55887 0 18.5 0C28.4411 0 36.5 8.05887 36.5 18ZM16.25 24.4952L25.25 19.299C26.25 18.7217 26.25 17.2783 25.25 16.701L16.25 11.5048C15.25 10.9275 14 11.6491 14 12.8038L14 23.1962C14 24.3509 15.25 25.0725 16.25 24.4952Z'
        fill={color ?? 'var(--color-primary)'}
      />
    </svg>
  );
};

export const PlayIconUnfilled: React.FC<{ color?: string; className?: string }> = ({ color, className }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.87469 5.45074L12.7319 8.46689C13.2016 8.68763 13.2016 9.26973 12.7319 9.53375L6.87469 12.5499C6.58008 12.7016 6.0007 12.5804 6 12.0165V5.98416C6 5.65279 6.35267 5.20714 6.87469 5.45074ZM7 11.3606L11.5835 9.00032L7 6.64006V11.3606Z'
        fill={color ?? 'var(--color-primary)'}
      />
    </svg>
  );
};
